import isSpecialFilter from './isSpecialFilter';

export default function (filters) {
    try {
        return Object.keys(filters).find(filterName => isSpecialFilter(filterName, filters[filterName]));
    } catch (ignore) {
        return false;
    }
}
